import React from 'react';
import AddTrackPanel from '../../components/panels/add-track-panel';
import TrackOrderPanel from '../../components/panels/order/track-order-panel';
import GraphAdjustments from '../../components/panels/graph-adjustments/graph-adjustments';
import BoreholeCorrelationPanel from '../../components/panels/group/borehole-correlation-panel';
import AddStatisticsPanel from '../../components/panels/add-statitics-panel';

interface RightSidePanelProps {
  showRightSidePanel: boolean;
  showAddTrackPanel: boolean;
  showReorderPanel: boolean;
  showAdjustmentsPanel: boolean;
  showCorrelationPanel: boolean;
  showAddStatisticsPanel: boolean;
  statisticsTracks: any[];
  onAddStatisticalTrack: (trackTypes: any[]) => void;
  onDeleteStatisticalTrack: (trackType: any) => void;
  // AddTrackPanel props
  onAddTrack: (formData: any) => void;
  selectedTrackType: number | null;
  setSelectedTrackType: (value: number | null) => void;
  selectedTrackTypeIds: number[];
  setSelectedTrackTypeIds: React.Dispatch<React.SetStateAction<number[]>>;
  selectedTemplateTrackType: number;
  setSelectedTemplateTrackType: (value: number) => void;
  allowedTrackCategories?: number[];
  checkedImageTypes: number[];
  setCheckedImageTypes: React.Dispatch<React.SetStateAction<number[]>>;
  checkedLithologyTypes: number[];
  setCheckedLithologyTypes: React.Dispatch<React.SetStateAction<number[]>>;
  checkedStratigraphyTypes: number[];
  setCheckedStratigraphyTypes: React.Dispatch<React.SetStateAction<number[]>>;
  checkedTextTypes: number[];
  setCheckedTextTypes: React.Dispatch<React.SetStateAction<number[]>>;
  imageTypes: any[];
  selectedChartCategory: string | null;
  setSelectedChartCategory: (category: string | null) => void;
  trackTypesHierarchyData: any;
  trackTypesHierarchyLoading: boolean;
  onHideAddTrackPanel: () => void;
  // TrackOrderPanel props
  sortedTrackData: any[];
  trackOrderData: any[];
  onUpdateTrackOrder: (sourceIndex: number, destinationIndex: number) => void;
  onUpdateGroupTrackOrder: (sourceGroupId: any, destinationGroupId: any, sourceIndex: number, destinationIndex: number, applyToAll: boolean) => void;
  onUpdateGroupOrder: (sourceIndex: number, destinationIndex: number) => void;
  // GraphAdjustments props
  isViewMode: boolean;
  viewSortedGroupTrackData: any[];
  selectedTrack: any | null;
  setSelectedTrack: (track: any, groupId?: any) => void;
  selectedGroupId: any | null;
  setTrackCollapsed: (trackId: string, collapsed: boolean, groupId?: any) => void;
  updateCurves: (trackId: string, curves: any, groupId?: any) => void;
  setShowGridlines: (trackId: string, show: boolean) => void;
  setScaleType: (trackId: string, scaleType: number) => void;
  deleteTrack: (trackTypeId: any, trackId?: any, groupId?: any) => void;
  addCurve: (trackId: any) => void;
  clientId: string | null;
  onChangeDataValue: (id: number | undefined, trackTypeId: number, value: any, color: string, lithologyLexiconId: string, boreholeId: number, depth?: number) => void;
  onAddDataValue: (trackTypeId: any, depth: any, value: any, color: string, lithologyLexiconId: string, boreholeId: number) => void;
  onDeleteDataValue: (trackTypeId: any, id: string, boreholeId: number) => void;
  onSaveLithologyData: (trackTypeId: any, boreholeId: number) => void;
  onChangeTextData: (trackTypeId: any, data: any, boreholeId: number) => void;
  onAddTextValue: (textTrackTypeId: any, fromDepth: number, toDepth: number, value: any, boreholeId: number) => boolean;
  onSaveTextData: (trackTypeId: any, data: any, boreholeId: number) => void;
  onChangeStratigraphyData: (trackTypeId: any, data: any, boreholeId: number) => void;
  onAddStratigraphyValue: (stratigraphyTrackTypeId: any, fromDepth: number, toDepth: number, lexicon: any, boreholeId: number) => boolean;
  onSaveChangeStratigraphyData: (trackTypeId: any, data: any, boreholeId: number) => Promise<void>;
  onChangeDepth: (trackTypeId: any, id: string, newDepth: any) => void;
  onSetTrackEditMode: (trackId: any, editMode: boolean) => void;
  // BoreholeCorrelationPanel props
  boreholesByProject: any[];
  projectId: string | null;
  boreholeId: string | number | null;
  onAddBoreholes: (boreholes: any[]) => void;
  viewportHeight: number;
  startDepth: number | null;
  endDepth: number | null;
  depthUnit: string | null;
  boreholeTextTrackData?: Record<string, any[]>;
  boreholeStratigraphyTrackData?: Record<string, any[]>;
}

const noop = () => {};

const RightSidePanel: React.FC<RightSidePanelProps> = ({
  showRightSidePanel,
  showAddTrackPanel,
  showReorderPanel,
  showAdjustmentsPanel,
  showCorrelationPanel,
  showAddStatisticsPanel,
  statisticsTracks,
  onAddStatisticalTrack,
  onDeleteStatisticalTrack,
  onAddTrack,
  selectedTrackType,
  setSelectedTrackType,
  selectedTrackTypeIds,
  setSelectedTrackTypeIds,
  selectedTemplateTrackType,
  setSelectedTemplateTrackType,
  allowedTrackCategories,
  checkedImageTypes,
  setCheckedImageTypes,
  checkedLithologyTypes,
  setCheckedLithologyTypes,
  checkedStratigraphyTypes,
  setCheckedStratigraphyTypes,
  checkedTextTypes,
  setCheckedTextTypes,
  imageTypes,
  selectedChartCategory,
  setSelectedChartCategory,
  trackTypesHierarchyData,
  trackTypesHierarchyLoading,
  onHideAddTrackPanel,
  sortedTrackData,
  trackOrderData,
  onUpdateTrackOrder,
  onUpdateGroupTrackOrder,
  onUpdateGroupOrder,
  isViewMode,
  viewSortedGroupTrackData,
  selectedTrack,
  setSelectedTrack,
  selectedGroupId,
  setTrackCollapsed,
  updateCurves,
  setShowGridlines,
  setScaleType,
  deleteTrack,
  addCurve,
  clientId,
  onChangeDataValue,
  onAddDataValue,
  onDeleteDataValue,
  onSaveLithologyData,
  onChangeTextData,
  onAddTextValue,
  onSaveTextData,
  onChangeStratigraphyData,
  onAddStratigraphyValue,
  onSaveChangeStratigraphyData,
  onChangeDepth,
  onSetTrackEditMode,
  boreholesByProject,
  projectId,
  boreholeId,
  onAddBoreholes,
  viewportHeight,
  startDepth,
  endDepth,
  depthUnit,
  boreholeTextTrackData,
  boreholeStratigraphyTrackData,
}) => {
  return (
    <div className="right-side-panel" style={{ width: showRightSidePanel ? 427 : 0 }}>
      {showAddTrackPanel && (
        <AddTrackPanel
          onAddTrackFormSubmit={onAddTrack}
          selectedTrackType={selectedTrackType}
          setSelectedTrackType={setSelectedTrackType}
          trackTypeCategories={trackTypesHierarchyData?.trackTypeCategories}
          trackTypesDataIsLoading={trackTypesHierarchyLoading}
          checkedTrackTypes={selectedTrackTypeIds}
          setCheckedTrackTypes={setSelectedTrackTypeIds}
          selectedTemplateTrackType={selectedTemplateTrackType}
          setSelectedTemplateTrackType={setSelectedTemplateTrackType}
          checkedImageTypes={checkedImageTypes}
          setCheckedImageTypes={setCheckedImageTypes}
          checkedLithologyTypes={checkedLithologyTypes}
          setCheckedLithologyTypes={setCheckedLithologyTypes}
          checkedStratigraphyTypes={checkedStratigraphyTypes}
          setCheckedStratigraphyTypes={setCheckedStratigraphyTypes}
          checkedTextTypes={checkedTextTypes}
          setCheckedTextTypes={setCheckedTextTypes}
          imageTypes={imageTypes}
          selectedTrackCategory={selectedChartCategory}
          setSelectedTrackCategory={setSelectedChartCategory}
          allowedTrackCategories={allowedTrackCategories || [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]}
          onClose={onHideAddTrackPanel}
        />
      )}
      {showReorderPanel && (
        trackOrderData && trackOrderData.length > 0 ? (
          <TrackOrderPanel
            tracks={trackOrderData}
            updateTrackOrder={onUpdateTrackOrder}
            updateGroupTrackOrder={onUpdateGroupTrackOrder}
            updateGroupOrder={onUpdateGroupOrder}
          />
        ) : (
          <div style={{ padding: '16px', fontSize: '12px', color: '#999' }}>
            <p>No tracks available. Select a template to reorder tracks.</p>
          </div>
        )
      )}
      {showAdjustmentsPanel && (
        sortedTrackData && sortedTrackData.length > 0 ? (
          <GraphAdjustments
            tracks={sortedTrackData}
            groups={isViewMode ? viewSortedGroupTrackData : []}
            showView={isViewMode}
            setSelectedTrack={setSelectedTrack}
            setTrackCollapsed={setTrackCollapsed}
            trackTypeCategories={trackTypesHierarchyData?.trackTypeCategories}
            selectedTrack={selectedTrack}
            selectedGroupId={selectedGroupId}
            updateCurves={updateCurves}
            setShowGridlines={setShowGridlines}
            setScaleType={setScaleType}
            deleteTrack={deleteTrack}
            addCurve={addCurve}
            clientId={clientId || ''}
            changeDataValue={onChangeDataValue}
            saveLithologyData={onSaveLithologyData}
            saveTextData={onSaveTextData}
            changeDepth={onChangeDepth}
            addDataValue={onAddDataValue}
            addTextValue={onAddTextValue}
            changeTextData={onChangeTextData}
            changeStratigraphyData={onChangeStratigraphyData}
            saveChangeStratigraphyData={onSaveChangeStratigraphyData}
            addStratigraphyValue={onAddStratigraphyValue}
            deleteDataValue={onDeleteDataValue}
            selectedLithologyId={null}
            setSelectedLithologyId={noop}
            showAdjustmentsPanel={showAdjustmentsPanel}
            setTrackEditMode={onSetTrackEditMode}
            dataNotSaved={[]}
            boreholes={[]}
            lithologyTrackTypes={[]}
            getLithologyDataForHorizontalBarChart={noop}
            depthUnit={depthUnit}
          />
        ) : (
          <div style={{ padding: '16px', fontSize: '12px', color: '#999' }}>
            <p>No tracks available. Select a template to view adjustments.</p>
          </div>
        )
      )}
      {showAddStatisticsPanel && (
        <AddStatisticsPanel
          addStatisticalTrack={onAddStatisticalTrack}
          deleteStatisticalTrack={onDeleteStatisticalTrack}
          statisticsTracks={statisticsTracks}
        />
      )}
      {showCorrelationPanel && (
        <BoreholeCorrelationPanel
          onClose={onHideAddTrackPanel}
          boreholesByProject={boreholesByProject}
          clientId={(clientId as any) || ''}
          projectId={(projectId as any) || ''}
          boreholeId={boreholeId as any}
          tracks={sortedTrackData}
          addBoreholes={onAddBoreholes}
          pixelHeight={viewportHeight}
          startDepth={startDepth as any}
          endDepth={endDepth as any}
          byBoreholeDepth={true}
          depthUnit={depthUnit as any}
          boreholeTextTrackData={boreholeTextTrackData ?? {}}
          boreholeStratigraphyTrackData={boreholeStratigraphyTrackData ?? {}}
          trackTypesHierarchyData={trackTypesHierarchyData}
        />
      )}
    </div>
  );
};

export default RightSidePanel;
